module.exports = __webpack_public_path__ + "img/cards_back-pold-2.f91bd9ce.png";